import React, { useContext, useState, useCallback } from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import _noop from 'lodash/noop';
import _get from 'lodash/get';

import { ModalContext, AppContext, Loader } from 'commons-ui';
import { UserDetailsContext } from 'context/userDetails';
import { IContentProps } from '../types';
import useService from '../../useService';

const Content = (props: IContentProps) => {
	const { handleForceUpdate = _noop } = props;
	const [css] = useStyletron();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);
	const {
		selectedUser: { zupeeUserId }
	} = useContext(UserDetailsContext);

	const { cancelSubscription } = useService();

	const handleCancel = useCallback(() => {
		setModalConfig({ isOpen: false });
	}, [setModalConfig]);

	const handleConfirm = useCallback(async () => {
		try {
			setIsLoading(true);
			const result = await cancelSubscription();
			const isSuccess = _get(result, ['data', 'success'], false);

			if (isSuccess) {
				showAlert('Subscription cancellation request submitted successfully', { type: 'success' });
				handleForceUpdate();
			} else {
				const errorMessage = _get(result, ['data', 'error'], 'Failed to cancel subscription');
				showAlert(errorMessage, { type: 'error' });
			}
		} catch (error) {
			showAlert('An error occurred while canceling subscription', { type: 'error' });
		} finally {
			setIsLoading(false);
			setModalConfig({ isOpen: false });
		}
	}, [cancelSubscription, handleForceUpdate, setModalConfig, showAlert]);

	if (isLoading) {
		return <Loader />;
	}

	return (
		<div className={css({ width: '400px', padding: '16px' })}>
			<p className={css({ fontSize: '16px', lineHeight: '24px', margin: '0 0 8px 0' })}>
				Are you sure you want to cancel all subscriptions for user <strong>{zupeeUserId}</strong>?
			</p>
			<p className={css({ fontSize: '14px', lineHeight: '20px', margin: '0', color: '#666' })}>
				This action will cancel all active subscriptions for this user.
			</p>
			<div
				className={css({
					display: 'flex',
					justifyContent: 'flex-end',
					gap: '12px',
					marginTop: '24px'
				})}>
				<Button kind='secondary' onClick={handleCancel}>
					Cancel
				</Button>
				<Button kind='primary' onClick={handleConfirm}>
					Confirm
				</Button>
			</div>
		</div>
	);
};

export default Content;
